<template>
  <div>
    <audio @timeupdate="updateProgress" controls ref="audioRef" style="display: none">
      <source :src="audioUrl" type="audio/mpeg" />
    </audio>
    <div class="audio-right">
      <i :class="audioStatus !== 'pause' ? 'iconfont icon-bofang' : 'iconfont icon-zanting'"  @click="handlePlayAudio" class="nomal dialogAudioPlay audioIconfont"></i>
      <div class="progress-bar-bg" :id="'progressBarBg' + subscript" v-dragto="setAudioIcon">
        <div class="progress-bar" :id="'progressBar' + subscript"></div>
      </div>
      <div class="audio-time" style="min-height: 10px">
        <span class="audio-length-current" :id="'audioCurTime' + subscript">{{ audioStart }}</span
        >/
        <span class="audio-length-total">{{ duration }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    fileurl: {
      trpe: String
    },
    subscript: {
      type: Number
    }
  },
  data() {
    return {
      audioStatus: 'play',
      audioStart: '0:00',
      duration: '0:00',
      mute: false,
      audioUrl: '',
      audioDuration: 0
    }
  },

  directives: {
    dragto: {
      inserted: function(el, binding, vnode) {
        el.addEventListener(
          'click',
          e => {
            let that = vnode.context
            let wdiv = document.getElementById('progressBarBg' + that.subscript).clientWidth
            let audio = vnode.context.$refs.audioRef
            // console.log('subscript', that.subscript)
            // 只有音乐开始播放后才可以调节，已经播放过但暂停了的也可以
            let ratemin = e.offsetX / wdiv
            let rate = ratemin * 100
            document.getElementById('progressBar' + that.subscript).style.width = rate + '%'
            audio.currentTime = audio.duration * ratemin
            audio.play()
            that.handlePlayAudio('drag')
            binding.value()
          },
          false
        )
      }
    }
  },
  computed: {
    audioIcon() {
      if (this.audioHuds) {
        return this.mute ? 'checked icon-jingyin' : 'checked icon-shengyin'
      } else {
        return 'icon-shengyin nomal'
      }
    }
  },
  watch: {
    fileurl: {
      handler(nVal) {
        this.audioUrl = nVal
      },
      immediate: true
    }
  },
  mounted() {
    this.fetch()
  },
  methods: {
    fetch() {
      let that = this
      var myVid = this.$refs.audioRef
      myVid.loop = false
      that.duration = '00:00'
      myVid.load()
      this.audioStatus = 'play'
      document.getElementById('progressBar' + that.subscript).style.width = '0%'
      // 监听音频播放完毕
      myVid.addEventListener(
        'ended',
        function() {
          that.audioStatus = 'play' // 显示播放icon
          document.getElementById('progressBar' + that.subscript).style.width = '0%' // 进度条初始化
          that.audioStart = '00:00'
        },
        false
      )
      if (myVid != null) {
        // let cutNum = 0
        myVid.oncanplay = function() {
          that.duration = that.transTime(myVid.duration) // 计算音频时长
          // 超过90s提示建议缩减音频
          // cutNum++
          // if (myVid.duration > 90 && cutNum === 1) {
          //   that.$message.error(that.$t('robot.suggest_cut'))
          // }
        }
        // myVid.volume = 0.28 // 设置音量28%
      }
    },
    // 播放暂停控制
    handlePlayAudio(type) {
      this.$emit('playAudio', this.subscript, type)
    },
    playAudio() {
      let recordAudio = this.$refs.audioRef // 获取audio元素
      if (recordAudio.paused) {
        recordAudio.play()
        this.audioStatus = 'pause'
      } else {
        recordAudio.pause()
        this.audioStatus = 'play'
      }
    },
    // 更新进度条与当前播放时间
    updateProgress(e) {
      var value = e.target.currentTime / e.target.duration
      if (document.getElementById('progressBar' + this.subscript)) {
        document.getElementById('progressBar' + this.subscript).style.width = value * 100 + '%'
        if (e.target.currentTime === e.target.duration) {
          this.audioStatus = 'pause'
        }
      } else {
        this.audioStatus = 'pause'
      }

      this.audioStart = this.transTime(this.$refs.audioRef.currentTime)
    },
    /**
     * 音频播放时间换算
     * @param {number} value - 音频当前播放时间，单位秒
     */
    transTime(time) {
      var duration = parseInt(time)
      var minute = parseInt(duration / 60)
      var sec = (duration % 60) + ''
      var isM0 = ':'
      if (minute === 0) {
        minute = '00'
      } else if (minute < 10) {
        minute = '0' + minute
      }
      if (sec.length === 1) {
        sec = '0' + sec
      }
      return minute + isM0 + sec
    },
    setAudioIcon() {
      this.audioStatus = 'pause'
    },
    resultAudio(index) {
      let recordAudio = this.$refs.audioRef // 获取audio元素
      recordAudio.pause()
      this.audioStatus = 'play'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/variables.scss';
.volume {
  position: absolute;
  display: flex;
  right: 16px;
  bottom: 1px;
  flex-direction: column;
  align-content: center;
  .volume-progress {
    width: 32px;
    height: 140px;
    background: #f6f6f6;
    border-radius: 4px;
    padding-top: 10px;
    margin-bottom: 10px;
  }
  .volume-bar-bg {
    margin: 0 auto;
    width: 6px;
    height: 120px;
    background: #dcdcdc;
    border-radius: 100px;
    flex: 1;
    position: relative;
    transform: rotate(180deg);
    cursor: pointer;
    .volume-bar {
      width: 6px;
      height: 28%;
      background: $base-primary;
      border-radius: 100px;
    }
  }
  .checked {
    color: $base-primary;
  }
}
.nomal {
  color: $base-text-regular;
}
.audio-right {
  width: 100%;
  height: 56px;
  line-height: 57px;
  // background: #f6f6f6;
  border-radius: 6px;
  display: flex;
  .audioIconfont {
    font-size: 24px;
  }
  .dialogAudioPlay {
    cursor: pointer;
    font-size: 24px;
  }
  .progress-bar-bg {
    background-color: #dcdcdc;
    overflow: hidden;
    flex: 1;
    position: relative;
    height: 6px;
    border-radius: 5px;
    top: 50%;
    transform: translateY(-50%);
    margin-top: -1px;
    cursor: pointer;
    margin: 0 10px;
  }
  .progress-bar {
    background-color: $base-primary;
    width: 0%;
    height: 6px;
    border-radius: 5px;
  }

  .audio-time {
    overflow: hidden;
    font-size: 12px;
    .audio-length-total {
      float: right;
    }
    .audio-length-current {
      float: left;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Template/RobotExperience/components/audioPlayer.vue